import { render, staticRenderFns } from "./home.vue?vue&type=template&id=24f33831&scoped=true&"
import script from "./home.js?vue&type=script&lang=js&"
export * from "./home.js?vue&type=script&lang=js&"
import style0 from "./home.css?vue&type=style&index=0&id=24f33831&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f33831",
  null
  
)

export default component.exports